
(() => {
  const END_KEY = 'elvaras_cart_reservation_end';
  const DURATION_KEY = 'elvaras_cart_reservation_duration';
  let fallbackEnd = null;
  let fallbackDuration = null;

  const storage = {
    get(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return key === END_KEY ? fallbackEnd : fallbackDuration;
      }
    },
    set(key, value) {
      try {
        window.sessionStorage.setItem(key, String(value));
      } catch (error) {
        if (key === END_KEY) fallbackEnd = String(value);
        if (key === DURATION_KEY) fallbackDuration = String(value);
      }
    }
  };

  const pad = (value) => String(value).padStart(2, '0');

  const getState = (durationSeconds, behavior) => {
    const now = Date.now();
    const storedDuration = Number(storage.get(DURATION_KEY));
    let end = Number(storage.get(END_KEY));

    if (!Number.isFinite(end) || storedDuration !== durationSeconds) {
      end = now + durationSeconds * 1000;
      storage.set(END_KEY, end);
      storage.set(DURATION_KEY, durationSeconds);
    }

    let remaining = Math.max(0, Math.ceil((end - now) / 1000));

    if (remaining <= 0 && behavior === 'restart') {
      end = now + durationSeconds * 1000;
      storage.set(END_KEY, end);
      remaining = durationSeconds;
    }

    return { remaining: remaining, end: end };
  };

  const render = () => {
    const timers = Array.from(document.querySelectorAll('[data-cart-reservation-timer]'));
    if (!timers.length) return;

    const first = timers[0];
    const durationMinutes = Math.max(1, Number(first.dataset.durationMinutes) || 10);
    const durationSeconds = durationMinutes * 60;
    const behavior = first.dataset.expiryBehavior || 'restart';
    const state = getState(durationSeconds, behavior);

    timers.forEach((timer) => {
      const timeEl = timer.querySelector('[data-cart-reservation-time]');
      const labelEl = timer.querySelector('[data-cart-reservation-label]');
      const progressEl = timer.querySelector('[data-cart-reservation-progress]');
      if (!timeEl) return;

      const minutes = Math.floor(state.remaining / 60);
      const seconds = state.remaining % 60;
      timeEl.textContent = pad(minutes) + ':' + pad(seconds);

      const urgent = timer.dataset.pulseLastMinute === 'true' && state.remaining > 0 && state.remaining <= 60;
      timeEl.classList.toggle('is-urgent', urgent);

      if (state.remaining <= 0 && behavior === 'stop' && labelEl) {
        const expiredText = timer.dataset.expiredText || '';
        if (expiredText) labelEl.textContent = expiredText;
      }

      if (progressEl) {
        const ratio = Math.max(0, Math.min(1, state.remaining / durationSeconds));
        progressEl.style.transform = 'scaleX(' + ratio + ')';
      }
    });
  };

  const start = () => {
    render();
    window.setInterval(render, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', render);
})();
